module.exports = __webpack_public_path__ + "static/media/Enrollments.475e4a80.svg";